import { HR_MANAGE_MEETING } from '../MeetingMutations'
import {
  Country,
  HrManageMeetingInput,
  HrSupportFeedbackTabFilter,
  CursorPaginationMeetingInput,
  ManagerCloseMeetingMutation,
} from '../../../types'
import { ApolloError, FetchResult, useMutation } from '@apollo/client'
import { APPRAISALS_WITH_FEEDBACK_BY_COUNTRY_AND_FILTERS, APPRAISALS_WITH_FEEDBACK_COUNTER_BY_COUNTRY } from '../MeetingQueries'

export const useHrManageMeeting = (): {
  hrManageMeeting: (
    hrManageMeetingInput: HrManageMeetingInput,
    country: Country,
    filters: HrSupportFeedbackTabFilter,
    pagination?: CursorPaginationMeetingInput,
  ) => Promise<FetchResult<ManagerCloseMeetingMutation>>
  data: ManagerCloseMeetingMutation
  loading: boolean
  error: ApolloError | undefined
} => {
  const [manageMeeting, { loading, error, data }] = useMutation(HR_MANAGE_MEETING)
  const hrManageMeeting = (
    hrManageMeetingInput: HrManageMeetingInput,
    country: Country,
    filters: HrSupportFeedbackTabFilter,
    pagination?: CursorPaginationMeetingInput,
  ): Promise<FetchResult<ManagerCloseMeetingMutation>> => {
    return manageMeeting({
      variables: {
        hrManageMeetingInput: hrManageMeetingInput,
      },
      refetchQueries: pagination
        ? [
            {
              query: APPRAISALS_WITH_FEEDBACK_BY_COUNTRY_AND_FILTERS,
              variables: {
                country,
                filters,
                pagination,
              },
            },
            {
              query: APPRAISALS_WITH_FEEDBACK_COUNTER_BY_COUNTRY,
              variables: {
                country,
              },
            },
          ]
        : [],
    })
  }
  return { hrManageMeeting, data, loading, error }
}
